<template>
  <div class="sticky top-0 z-10 pt-4 bg-base-300/30 backdrop-blur-md rounded-b-[1.2rem]">
    <header
      class="navbar bg-base-100 shadow-md border-b-2 border-base-content/10 rounded-[1.2rem] space-x-3"
    >
      <div class="flex-none hidden lg:block">
        <button class="btn btn-square btn-ghost" @click="toggleSidebar">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="inline-block h-5 w-5 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </button>
      </div>

      <!-- mobile menu -->
      <NavMobile />

      <div class="flex-1">
        <img src="@/assets/logo/logo-dark.png" alt="logo" class="w-16 lg:hidden" />
      </div>
      <div class="flex-none">
        <label class="swap swap-rotate">
          <!-- this hidden checkbox controls the state -->
          <input type="checkbox" class="theme-controller" v-model="theme" />

          <!-- sun icon -->
          <svg
            class="swap-off h-6 w-6 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path
              d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"
            />
          </svg>

          <!-- moon icon -->
          <svg
            class="swap-on h-6 w-6 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path
              d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z"
            />
          </svg>
        </label>
      </div>
      <NavNotifikasi />

      <div class="flex-none">
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" :class="['avatar', isOnline ? 'avatar-online' : '']">
            <div class="w-10 rounded-full">
              <img :src="user.image" />
            </div>
          </div>
          <ul
            tabindex="0"
            class="dropdown-content menu bg-base-300 rounded-box z-1 w-52 p-2 shadow-sm"
          >
            <li>
              <button class="btn" @click="useAuth.logout()">Logout</button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { useAuthStore, useUtilsStore } from '@/stores'
import NavMobile from './NavMobile.vue'
import NavNotifikasi from './widget/NavNotifikasi.vue'
// import IconLucide from '@/components/icons/IconLucide.vue'

// Enum for theme types
enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export default defineComponent({
  name: 'NavHeader',
  components: { NavMobile, NavNotifikasi },
  setup() {
    const useAuth = useAuthStore()
    const useUtils = useUtilsStore()
    const theme = ref(false)
    const isOnline = computed(() => useUtils.isOnline)
    const user = computed(() => useAuth.user)

    const toggleSidebar = () => {
      useUtils.toogleSidebar()
    }

    const setTheme = (newTheme: Theme) => {
      useUtils.toogleTheme(newTheme)
    }

    onMounted(() => {
      const savedTheme = localStorage.getItem('theme') as Theme
      useUtils.toogleTheme(savedTheme || Theme.LIGHT)
      theme.value = savedTheme === Theme.DARK
    })

    watch(theme, (newValue) => {
      setTheme(newValue ? Theme.DARK : Theme.LIGHT)
    })

    return {
      useAuth,
      theme,
      toggleSidebar,
      isOnline,
      user,
    }
  },
})
</script>

<style></style>
